import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { ApolloClient, HttpLink } from "@apollo/client";
import { ApolloLink } from "@apollo/client/link/core";
import { onError } from "@apollo/client/link/error";
import { useMemo } from "react"; // BatchHttpLinkを使うとPersistedQueryのGETリクエストが使えない
// import { BatchHttpLink } from "@apollo/client/link/batch-http";

import cache from "@/apollo/cache/index";
import createDataSources from "@/apollo/datasources/index";
import { GET_ADULT_MODE } from "@/apollo/queries/adultMode";
import { AUTH_LOGOUT_MUTATION, AUTH_USER } from "@/apollo/queries/user";
import schema from "@/apollo/schemas/index";
import routes from "@/lib/routes";
import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { RetryLink } from "@apollo/client/link/retry";
import { SchemaLink } from "@apollo/client/link/schema";
import { sha256 } from "crypto-hash";
import Router from "next/router";
var apolloClient; // ユーザーと選択しているプロフィールののratingでキャッシュされるようにextensionsに値をいれる

var AddExtensionsLink = new ApolloLink(function (operation, forward) {
  var _operation$getContext = operation.getContext(),
      cache = _operation$getContext.cache;

  var adult = cache.readQuery({
    query: GET_ADULT_MODE
  });

  if (adult) {
    operation.extensions.adultMode = adult.adultMode;
  }

  var user = cache.readQuery({
    query: AUTH_USER
  });

  if (user) {
    var _user$user, _user$user2, _user$user2$currentPr;

    operation.extensions.user = {
      uuid: user === null || user === void 0 ? void 0 : (_user$user = user.user) === null || _user$user === void 0 ? void 0 : _user$user.uuid,
      rating: user === null || user === void 0 ? void 0 : (_user$user2 = user.user) === null || _user$user2 === void 0 ? void 0 : (_user$user2$currentPr = _user$user2.currentProfile) === null || _user$user2$currentPr === void 0 ? void 0 : _user$user2$currentPr.rating
    };
  }

  return forward(operation);
}); // SSRとCSRでリンクを変える

function createIsomorphLink() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (false) {
    return new SchemaLink({
      schema: schema,
      context: function context() {
        var dataSources = createDataSources({
          req: req
        });
        var context = {
          req: req,
          res: res,
          dataSources: dataSources
        };
        Object.values(dataSources).forEach(function (dataSource) {
          if (dataSource.initialize) {
            dataSource.initialize({
              context: context
            });
          }
        });
        return context;
      }
    });
  } else {
    var logout = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var client;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = initializeApollo(); // cookieからトークンを削除するためにlogoutをコールする

                _context.next = 3;
                return client.mutate({
                  mutation: AUTH_LOGOUT_MUTATION,
                  variables: {
                    force: true
                  }
                });

              case 3:
                _context.next = 5;
                return client.resetStore();

              case 5:
                Router.replace(routes["401"]);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function logout() {
        return _ref.apply(this, arguments);
      };
    }();

    return ApolloLink.from([onError(function (_ref2) {
      var graphQLErrors = _ref2.graphQLErrors,
          networkError = _ref2.networkError;

      if (graphQLErrors) {
        graphQLErrors.forEach( /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
            var _extensions$response;

            var message, location, path, extensions;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    message = _ref3.message, location = _ref3.location, path = _ref3.path, extensions = _ref3.extensions;
                    console.log("[GraphQL Error] Message: ".concat(message, ", location: ").concat(location, ", path: ").concat(path, ", extensions: ").concat(JSON.stringify(extensions))); // authエラーだったら
                    // TODO:

                    if (!(message && message.includes("Unauthorized") || (extensions === null || extensions === void 0 ? void 0 : (_extensions$response = extensions.response) === null || _extensions$response === void 0 ? void 0 : _extensions$response.status) == 401 || (extensions === null || extensions === void 0 ? void 0 : extensions.code) === "UNAUTHENTICATED")) {
                      _context2.next = 5;
                      break;
                    }

                    _context2.next = 5;
                    return logout();

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }());
      }

      if (networkError) {
        // console.log(networkError.response);
        // console.log(networkError.statusCode);
        // console.log(`[Network Error] ${networkError}`);
        if (networkError.statusCode == 401) {
          logout().then(function () {
            return console.log("401 error logout exec");
          });
        }
      }
    }), new RetryLink({
      delay: {
        initial: 300,
        max: Infinity,
        jitter: true
      },
      attempts: {
        max: 3,
        retryIf: function retryIf(error, _operation) {
          return !!error;
        }
      }
    }), createPersistedQueryLink({
      sha256: sha256,
      useGETForHashedQueries: true
    }), AddExtensionsLink, new HttpLink({
      uri: "/api/graphql",
      credentials: "same-origin"
    })]);
  }
}

export function createApolloClient() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var client = new ApolloClient({
    ssrMode: false,
    cache: cache(),
    link: createIsomorphLink(req, res),
    ssrForceFetchDelay: 100,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first"
      }
    },
    useGETForQueries: true,
    resolvers: {
      DeviceInfo: {
        isWebView: function isWebView(parentObj) {
          if (true) {
            var queryString = _toConsumableArray(new URLSearchParams(window.location.search).entries()).reduce(function (obj, e) {
              return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, e[0], e[1]));
            }, {});

            if (queryString !== null && queryString !== void 0 && queryString.in_app || parentObj.isApp) {
              return true;
            }
          }

          return parentObj.isApp;
        }
      }
    }
  });
  return client;
}
export function initializeApollo() {
  var _apolloClient2;

  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _apolloClient = (_apolloClient2 = apolloClient) !== null && _apolloClient2 !== void 0 ? _apolloClient2 : createApolloClient(req, res);

  if (initialState) {
    var existingCache = _apolloClient.extract();

    _apolloClient.cache.restore(_objectSpread(_objectSpread({}, existingCache), initialState));
  } // For SSG and SSR always create a new Apollo Client


  if (false) return _apolloClient; // Create the Apollo Client once in the client

  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
}
export function useApollo(initialState) {
  var store = useMemo(function () {
    return initializeApollo(initialState);
  }, [initialState]);
  return store;
}